import React from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useTenant } from '../../lib/tenant-context';
import { useLoyaltyDashboard } from '../../lib/loyalty-hooks';
import { Card } from '../../components/ui/Card';
import { Users, Star, Gift, Trophy } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';
export function LoyaltyDashboardPage() {
  const {
    restaurant,
    role,
    signOut
  } = useTenant();
  const {
    customers,
    loading
  } = useLoyaltyDashboard(restaurant.restaurant_id);
  const totalCustomers = customers.length;
  const totalPoints = customers.reduce((sum, c) => sum + (c.current_points || 0), 0);
  const totalRewardsAvailable = customers.reduce((sum, c) => sum + (c.available_rewards_count || 0), 0);
  const totalRewardsRedeemed = customers.reduce((sum, c) => sum + (c.redeemed_rewards_count || 0), 0);
  return <AdminLayout restaurant={restaurant} role={role} onSignOut={signOut} data-id="element-2999">
      <div className="p-6 max-w-7xl mx-auto space-y-6" data-id="element-3000">
        <div data-id="element-3001">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-3002">
            Programa de Lealtad
          </h1>
          <p className="text-gray-500" data-id="element-3003">
            Gestiona tus clientes frecuentes y beneficios
          </p>
        </div>

        {/* KPIs */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-3004">
          <Card className="p-6" data-id="element-3005">
            <div className="flex items-center gap-4" data-id="element-3006">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3007">
                <Users className="w-6 h-6 text-blue-600" data-id="element-3008" />
              </div>
              <div data-id="element-3009">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3010">
                  Clientes Leales
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3011">
                  {totalCustomers}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3012">
            <div className="flex items-center gap-4" data-id="element-3013">
              <div className="w-12 h-12 bg-yellow-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3014">
                <Star className="w-6 h-6 text-yellow-600" data-id="element-3015" />
              </div>
              <div data-id="element-3016">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3017">
                  Puntos Emitidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3018">
                  {totalPoints}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3019">
            <div className="flex items-center gap-4" data-id="element-3020">
              <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3021">
                <Gift className="w-6 h-6 text-green-600" data-id="element-3022" />
              </div>
              <div data-id="element-3023">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3024">
                  Beneficios Disponibles
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3025">
                  {totalRewardsAvailable}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3026">
            <div className="flex items-center gap-4" data-id="element-3027">
              <div className="w-12 h-12 bg-purple-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3028">
                <Trophy className="w-6 h-6 text-purple-600" data-id="element-3029" />
              </div>
              <div data-id="element-3030">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3031">
                  Beneficios Redimidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3032">
                  {totalRewardsRedeemed}
                </p>
              </div>
            </div>
          </Card>
        </div>

        {/* Customer Table */}
        <Card className="overflow-hidden" data-id="element-3033">
          <div className="p-6 border-b border-gray-200" data-id="element-3034">
            <h2 className="font-bold text-gray-900" data-id="element-3035">Directorio de Clientes</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-3036">
            <table className="w-full text-left text-sm" data-id="element-3037">
              <thead className="bg-gray-50 text-gray-500" data-id="element-3038">
                <tr data-id="element-3039">
                  <th className="px-6 py-4 font-medium" data-id="element-3040">Cliente</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3041">Teléfono</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3042">Visitas</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3043">
                    Total Gastado
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3044">
                    Ticket Promedio
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3045">Puntos</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3046">Nivel</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-3047">
                {loading ? <tr data-id="element-3048">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3049">
                      Cargando clientes...
                    </td>
                  </tr> : customers.length === 0 ? <tr data-id="element-3050">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3051">
                      No hay clientes registrados aún.
                    </td>
                  </tr> : customers.map(customer => <tr key={customer.customer_id} className="hover:bg-gray-50" data-id="element-3052">
                      <td className="px-6 py-4 font-medium text-gray-900" data-id="element-3053">
                        {customer.name || 'Sin nombre'}
                      </td>
                      <td className="px-6 py-4 text-gray-500" data-id="element-3054">
                        {customer.phone}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3055">
                        {customer.total_orders}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3056">
                        {formatCurrency(customer.total_spent, restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-500" data-id="element-3057">
                        {formatCurrency(customer.total_spent / Math.max(1, customer.total_orders), restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right font-bold text-brand-charcoal" data-id="element-3058">
                        {customer.current_points}
                      </td>
                      <td className="px-6 py-4" data-id="element-3059">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-3060">
                          {customer.current_level || 'Inicial'}
                        </span>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </AdminLayout>;
}